import { useEffect, useRef, useState } from 'react';
import { previewExecutionFile } from '../serviceExecutionApi';

export function ProcessedFilePreview({ preview, file, disabled, onChange, reviewable = true }: {
  preview?: { requestId: string; runId: string; role?: string };
  file: { id: string; filename: string; page_count?: number | null; visually_reviewed?: boolean };
  disabled: boolean;
  reviewable?: boolean;
  onChange: (reviewed: boolean) => void;
}) {
  const [url, setUrl] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const controller = useRef<AbortController | null>(null);
  const isPdf = /\.pdf$/i.test(file.filename);
  useEffect(() => {
    controller.current?.abort();
    setUrl('');
    setLoaded(false);
    setPending(false);
    setError('');
    return () => controller.current?.abort();
  }, [preview?.requestId, preview?.runId, preview?.role, file.id, file.filename]);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);
  const open = async () => {
    if (!preview) return;
    controller.current?.abort();
    const active = new AbortController();
    controller.current = active;
    setPending(true);
    setError('');
    try {
      const result = await previewExecutionFile(preview.requestId, preview.runId, file.id, preview.role, active.signal);
      if (active.signal.aborted) return;
      setLoaded(false);
      setUrl(URL.createObjectURL(result.blob));
    } catch (reason) {
      if (!active.signal.aborted) setError(reason instanceof Error ? reason.message : 'Не удалось загрузить файл');
    } finally {
      if (!active.signal.aborted) setPending(false);
    }
  };
  return <div>
    {preview && <button type="button" className="owner-uat-btn" disabled={pending} onClick={() => void open()}>{pending ? 'Загрузка файла…' : `Просмотреть ${file.filename}`}</button>}
    {error && <p role="alert">{error}</p>}
    {isPdf && <p>Проверьте все страницы готового PDF{file.page_count ? ` (${file.page_count})` : ''}: порядок, читаемость и оформление.</p>}
    {url && <figure>{isPdf ? <iframe title={`Результат: ${file.filename}`} src={url} style={{ width: '100%', height: 700, border: 0 }} onLoad={() => setLoaded(true)} /> : <img src={url} alt={`Результат: ${file.filename}`} style={{ maxWidth: '100%', maxHeight: 700, objectFit: 'contain' }} onLoad={() => setLoaded(true)} onError={() => { setLoaded(false); setError('Браузер не смог открыть изображение'); }} />}
      <figcaption><a href={url} target="_blank" rel="noopener noreferrer">{isPdf ? 'Открыть PDF в новой вкладке' : 'Открыть изображение в полном размере'}</a> · <a href={url} download={file.filename}>Скачать для проверки</a></figcaption>
    </figure>}
    {reviewable && <label><input type="checkbox" checked={!!file.visually_reviewed} disabled={disabled || !loaded && !file.visually_reviewed} onChange={(event) => onChange(event.target.checked)} /> {isPdf ? 'Проверил все страницы, их порядок и оформление' : 'Проверил читаемость, ориентацию и оформление'} · {file.filename}</label>}
  </div>;
}
